module.exports = __webpack_public_path__ + "static/img/produto_p.bf92eca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/antares-sgas/produto_p.png
// module id = sW8J
// module chunks = 0